import type { Material } from 'babylonjs';

/**
 * Force a set of materials to render unlit (texture-true albedo) for capture, and
 * return a restore function. PlaneFinders bake real-world lighting into the texture, so
 * unlit gives the true mural/photo without doubled shading. KHR_materials_unlit
 * glTFs are already unlit → no-op. Call the restore fn in a `finally`.
 */
export function swapToUnlit(materials: Material[]): () => void {
  const saved: { mat: { unlit: boolean }; prev: boolean }[] = [];
  for (const material of materials) {
    const mat = material as unknown as { unlit?: boolean };
    if (typeof mat.unlit === 'boolean') {
      saved.push({ mat: mat as { unlit: boolean }, prev: mat.unlit });
      mat.unlit = true;
    }
  }
  return () => {
    for (const s of saved) s.mat.unlit = s.prev;
  };
}
